export interface TransferrableDate {
  cardStackId: string | null
  unitStart: Array<string>
  unitEnd: Array<string>
}

export function createTransferrableDate(transferrableDate: TransferrableDate) {
  const defaults = {
    cardStackId: null,
    unitStart: [],
    unitEnd: [],
  }
  return Object.assign({}, defaults, transferrableDate)
}
